import store from '../../store'
import MembresiaBeneficios from '../Membresias/MembresiaBeneficios.js'
import moment from 'moment'
import { merge } from 'lodash'
import PGSHelper from '../../helpers/PGSHelper.js';
import Currencies from '../Currencies.js';

export default class MembresiaPlan {
    static typeSearch = "local"; //online || local
    Activo   = true;
    Id       = null;
    CA       = {C:null,M:Currencies.getCurrencyDefault()};
    CPA      = {C:null,M:Currencies.getCurrencyDefault()};
    Mnd      = Currencies.getCurrencyDefault();
    Nomb     = null;
    Cve    = "";
    NM       = 1;
    TIA      = 0;

    constructor(data) {
        this.Activo   = (data.Activo)?data.Activo:true;
        this.Id       = (data.Id)?data.Id:null;
        this.CA       = (data.CA)?data.CA:{M:Currencies.getCurrencyDefault(),C:0};
        this.CPA      = (data.CPA)?data.CPA:{M:Currencies.getCurrencyDefault(),C:0};
        this.Nomb     = (data.Nomb)?data.Nomb:'';
        this.Cve     = (data.Cve)?data.Cve:'';
        this.NM       = (data.NM)?data.NM:1;
        this.TIA      = (data.TIA)?data.TIA:1;
        this.typeSearch = "local"
    }

    static async getById(id){
        if(this.typeSearch == "online"){
            const data = await store.getters.getFirebaseApp.database
            .ref("MBS/Planes/"+id)
            .once("value");
            if (!data.exists()) {
                return false;
            }
            let datos = data.val();
            datos.Id = id;
            return new MembresiaPlan(datos);
        }else if(this.typeSearch == "local"){
            let pgsHelper  = new PGSHelper();
            let datos = pgsHelper.getById(store.getters["dataLists/getMbsPlanes"],'id',id);
            if(!datos){
                return false;
            }
            datos.Id = id;
            return new MembresiaPlan(datos);
        }
    }

    async getBeneficios(){
        return await MembresiaBeneficios.getByPlan(this.Id);
    }

    static getMembresiasPlanList(){
        /*if(this.typeSearch == "online"){
            const data = await store.getters.getFirebaseApp.database
            .ref("MBS/Planes")
            .once("value");
            if (!data.exists()) {
                return [];
            }else{
                let arrayPlanes = Object.entries(data.val());
                let planes = [];
                arrayPlanes.forEach(function (element) {
                    if(element[1].Activo){
                        planes.push(new MembresiaPlan({ Id: element[0], ...element[1] }));
                    }
                });
                return planes;
            }
        }else if(this.typeSearch == "local"){*/
            //en el pdv se contiene los datos en vuex, la variable typeSearch  indica a donde ir a buscarla
            let planes = [];
            let localData = store.getters["dataLists/getMbsPlanes"];
            localData.forEach((element)=>{
                if(element.Vrsn == 1){
                    planes.push(new MembresiaPlan({ Id: element.id, ...element }));
                }
            })
            return planes;
       /* }*/
    }

}